export const environment = {
  production: true,
  name: 'production',
  encryptionKey: 'go-roaming-frontend',
  apiPrefix: 'https://api.goroaming.net/api/v1',
  chillpay: {
    widgetScriptUrl: 'https://cdn.chillpay.co/js/widgets.js?v=1.00',
    paymentUrl: 'https://cdn.chillpay.co/Payment/'
  },
  auth: {
    login: '/auth/login',
    signup: '/auth/signup',
    config: '/auth/config',
    logout: '/auth/logout'
  },
  aisPackage: {
    aisPackages: '/ais-packages',
    detail: '/ais-packages/details',
    priceGroup: '/ais-packages/price-group',
    resellerPriceGroup: '/ais-packages/reseller-price-group'
  },
  package: {
    esimPackages: '/packages/esims'
  },
  subscription: {
    ais: '/subscription/ais',
    bulk: '/subscription/bulk',
    cancel: '/subscription/cancel',
    count: '/subscription/count',
    dataTopup: '/subscription/ais/data-topup',
    downloadHistory: '/subscription/download-history',
    esims: '/subscription/esims',
    history: '/subscription/history',
    scheduled: '/subscription/scheduled',
    downloadScheduledHistory: '/subscription/download-scheduled-history',
    switchRegistration: '/subscription/switch/registration',
    glingGringSubscription: '/subscription/gling-gring/topup',
    validate: '/subscription/validate',
    voiceRecharge: '/subscription/voice/recharge',
    pendingCart: '/subscription/pending-cart'
  },
  thaiEsim: {
    thaiEsims: '/thai-esims',
    sampleFile: '/thai-esims/sample-file'
  },
  user: {
    user: '/user',
    resellers: '/user/resellers'
  },
  activityLogs: {
    list: '/activity-logs'
  }
};
